import { render, staticRenderFns } from "./HowToUploadLetterComponent.vue?vue&type=template&id=2612759e&"
import script from "./HowToUploadLetterComponent.vue?vue&type=script&lang=js&"
export * from "./HowToUploadLetterComponent.vue?vue&type=script&lang=js&"
import style0 from "./HowToUploadLetterComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports